import { memo, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GameCard } from "./game-card";

export const TeamGames = memo(({ games, teamName }) => {
  const navigate = useNavigate();

  const seasons = useMemo(() => {
    if (!games || games.length === 0) return [];
    const years = [...new Set(games.map((g) => g.year || new Date(g.date).getFullYear()))];
    return years.sort((a, b) => b - a);
  }, [games]);

  const [selectedSeason, setSelectedSeason] = useState(() => seasons[0] || null);

  const handleGameClick = (game) => {
    navigate(`/games/${game.year}/${game.contest_id}`);
  };

  const handleTeamClick = (teamId) => {
    navigate(`/team/${teamId}`);
  };

  if (!games || games.length === 0) {
    return <div className="text-center py-12 text-gray-500">No games data available</div>;
  }

  const filteredGames = selectedSeason
    ? games.filter((g) => (g.year || new Date(g.date).getFullYear()) === selectedSeason)
    : games;

  const sortedGames = [...filteredGames].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

  const wins = filteredGames.filter((g) => g.result === "W").length;
  const losses = filteredGames.filter((g) => g.result === "L").length;
  const ties = filteredGames.filter((g) => g.result === "T").length;

  return (
    <div className="p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-4">
          <select
            value={selectedSeason || ""}
            onChange={(e) => setSelectedSeason(e.target.value ? Number(e.target.value) : null)}
            className="text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-lg px-3 py-1.5 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent cursor-pointer hover:border-gray-300 transition-colors"
          >
            {seasons.map((season) => (
              <option key={season} value={season}>
                {season} Season
              </option>
            ))}
          </select>
          <span className="text-sm text-gray-500">{filteredGames.length} Games</span>
          <div className="flex items-center gap-3 text-sm">
            <span className="text-green-600 font-semibold">{wins}W</span>
            <span className="text-red-600 font-semibold">{losses}L</span>
            {ties > 0 && <span className="text-gray-600 font-semibold">{ties}T</span>}
          </div>
        </div>
        <span className="text-xs text-gray-400">Click any game for details</span>
      </div>

      <div className="grid gap-3">
        {sortedGames.map((game, idx) => (
          <GameCard
            key={game.contest_id || idx}
            game={game}
            teamName={teamName}
            onGameClick={handleGameClick}
            onTeamClick={handleTeamClick}
          />
        ))}
      </div>
    </div>
  );
});

TeamGames.displayName = "TeamGames";
